import { createFileRoute } from "@tanstack/react-router";
import { PermissionLinkTemplate } from "~/features/permissionLink/PermissionLinkTemplate";
import { requestAttFromLink } from "~/lib/attPermissionLink";

// Repro のポップアップのリンク（carina:///att-permission 等）の受け口
export const Route = createFileRoute("/_authenticated/att-permission")({
  component: () => <PermissionLinkTemplate run={requestAttFromLink} />,
});
